import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="bg-white" data-id="element-41" data-mp="1nwvwmzb64jqt">
      <div className="mx-auto max-w-2xl px-3 py-5 sm:px-4 sm:py-8" data-id="element-42" data-mp="2blf4jdqb2uid">
        <SectionHeader id="faq" title="Preguntas frecuentes" data-id="element-43" data-mp="2flpipdo94r8b" />
        <div className="mt-3 space-y-1.5" data-id="element-44" data-mp="2fl64a6xt8kz1">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className={`rounded-xl border bg-gris transition-colors duration-150 ease-soft ${isOpen ? 'border-wifi' : 'border-navy/10'}`} data-id="element-45" data-mp="26t40pzsg2okj" data-mpi={i}>
                <h3 data-id="element-46" data-mp="2zbhunoantqec">
                  <button type="button" id={`faq-trigger-${i}`} onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-3 rounded-xl px-3 py-2 text-left" data-id="element-47" data-mp="2zbrk9arslvji">
                    <span className="text-[0.82rem] font-bold text-navy sm:text-sm" data-id="element-48" data-mp="20n19f2cb2amd">{faq.q}</span>
                    <ChevronDownIcon size={16} aria-hidden="true" className={`flex-shrink-0 text-wifi transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-49" data-mp="2ffl9fu45s1zl" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-50" data-mp="u1712zzsv0ds">
                  {isOpen && <motion.div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-trigger-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-51" data-mp="p249oicqssoa">
                      <p className="px-3 pb-2 text-[0.78rem] leading-snug text-negro/75 sm:text-sm" data-id="element-52" data-mp="382y63kqmjcej">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}